import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { decryptText, encryptText } from "../../utils/utils";

interface LanguageState {
    language: 'English' | 'Marathi';
}

// Try to load language from localStorage
let initialLanguage: 'English' | 'Marathi' = 'Marathi';
try {
    const storedLang = localStorage.getItem('app_language');
    if (storedLang) {
        const decrypted = decryptText(storedLang) as 'English' | 'Marathi';
        if (decrypted === 'English' || decrypted === 'Marathi') {
            initialLanguage = decrypted;
        }
    }
} catch (err) {
    console.warn('Failed to load language from localStorage', err);
}

const initialState: LanguageState = {
    language: initialLanguage,
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<'English' | 'Marathi'>) => {
            state.language = action.payload;
            try {
                const encrypted = encryptText(action.payload);
                localStorage.setItem('app_language', encrypted);
            } catch (err) {
                console.warn('Failed to save language to localStorage', err);
            }
        },
    },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
